import { Component } from '@angular/core';
import { fadeAnimationQuick } from '../../../animations/animations';
import { NavigationService } from '../services/navigation.service';

@Component({
    selector: 'cas-bottom-navigation-panel',
    templateUrl: './bottom-navigation-panel.component.html',
    styleUrls: ['./bottom-navigation-panel.component.scss'],
    animations: [
        fadeAnimationQuick
    ]
})
export class BottomNavigationPanelComponent {

    constructor(
        public navigationService: NavigationService) {
    }
}
